import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M11.48 12h12.522c0-1.083-.144-2.132-.413-3.13H11.48zM11.48 5.739h10.76a12 12 0 0 0-2.768-3.13H11.48zM12.001 24c2.824 0 5.42-.976 7.47-2.608H4.531A11.95 11.95 0 0 0 12.001 24M1.762 18.26h20.477a12 12 0 0 0 1.348-3.13H.414c.3 1.116.758 2.168 1.348 3.13\"></path><path fill=\"#0052B4\" d=\"M12 12V0C5.373 0 0 5.373 0 12z\"></path><path fill=\"#FFDA44\" d=\"M7.981 10.27a2.967 2.967 0 1 1 1.412-5.577 3.652 3.652 0 1 0 0 5.222c-.42.227-.901.356-1.412.356\"></path><path fill=\"#FFDA44\" d=\"m8.816 5.217.527 1.102 1.19-.275L10 7.143l.957.759-1.191.268.003 1.221-.953-.764-.952.764.003-1.22-1.191-.27.957-.758L7.1 6.044l1.19.275z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }